import { DndContext } from "@dnd-kit/core";
import { SortableContext, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import * as React from "react";

import { COMPONENT_READABLE_NAME } from "../../../utils/constants/common/componentName";
import styled from "@emotion/styled";
import Icon from "../../core/MyIcon";
import { useSetRecoilState } from "recoil";
import { TUseXElement, useXElementValue } from "../../../hooks/useXElement";
import { USE_SELECTED_INDEX } from "../../../hooks/useSelectedElement";
import { useXPage } from "../../../hooks/useXPage";
import { isCommon, useXCommonChildren } from "../../../hooks/useXCommon";

const XGUIOrderElementsTab: React.FC<{
  selectedElement: TUseXElement<any>;
  setSelectedElement: any;
}> = ({ selectedElement, setSelectedElement }) => {
  const { xPage, setXPage } = useXPage();
  const { xChildren, setXChildren } = useXCommonChildren(
    selectedElement.index as any
  );

  const indexes: string[] =
    selectedElement.name === "XPage"
      ? (xPage
          .map((e) => {
            console.log(e);

            if (e.config) {
              if (!e.config.childOf) return e.config.index;

              return "HIDDEN_" + e.config.index;
            }

            return null;
          })
          .filter((e) => typeof e === "string") as string[])
      : [...selectedElement.elementsIndexes];

  return (
    <DragContainer>
      <DndContext
        modifiers={[restrictToVerticalAxis]}
        onDragEnd={(e) => {
          if (e.over) {
            // UPDATE SUB ELEMENT
            if (selectedElement.name !== "XPage") {
              const _index = [...indexes];

              const overId = _index.indexOf(e.over.id as string);

              const activeId = _index.indexOf(e.active.id as string);

              _index.splice(activeId, 1);

              _index.splice(overId, 0, e.active.id as string);

              setSelectedElement((old: TUseXElement<any>) => ({
                ...old,
                elementsIndexes: _index,
              }));
            }

            // if (isCommon(selectedElement.index)) {
            // } else {
            const pages = isCommon(selectedElement.index)
              ? [...xChildren]
              : [...xPage];

            const overId = pages.findIndex((section) => {
              if (!section.config || !e.over) return false;

              return section.config.index === (e.over.id as string);
            });

            const activeId = pages.findIndex((section) => {
              if (!section.config || !e.active) return false;

              return section.config.index === (e.active.id as string);
            });

            const activeEl = pages.find((section) => {
              if (!section.config || !e.active) return false;

              return section.config.index === (e.active.id as string);
            });

            if (activeEl && activeId) {
              pages.splice(activeId, 1);

              pages.splice(overId, 0, activeEl);

              if (isCommon(selectedElement.index)) {
                setXChildren(pages);
              } else {
                setXPage(pages);
              }
            }
            console.log(overId, activeId, activeEl, pages);
            // }
          }
        }}
      >
        <SortableContext items={indexes}>
          {indexes.map((index) =>
            index.startsWith("HIDDEN_") ? null : (
              <DraggableElement index={index} key={index} />
            )
          )}
        </SortableContext>
      </DndContext>
    </DragContainer>
  );
};

export default XGUIOrderElementsTab;

const DraggableElement: React.FC<{ index: string }> = ({ index }) => {
  const setIndex = useSetRecoilState(USE_SELECTED_INDEX);

  const el = useXElementValue(index);

  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
  } = useSortable({ id: index });

  if (!el) return null;

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <li
      ref={setNodeRef}
      style={style}
      {...attributes}
      onMouseEnter={() => {
        const target = document.getElementById(index);

        if (target) target.setAttribute("data-x-hovered", "true");
      }}
      onMouseLeave={() => {
        const target = document.getElementById(index);

        if (target) target.removeAttribute("data-x-hovered");
      }}
    >
      <a
        onClick={() => {
          const other = document.querySelector("[data-x-selected='true']");

          if (other) other.removeAttribute("data-x-selected");

          const otherHover = document.querySelector("[data-x-hovered='true']");

          if (otherHover) otherHover.removeAttribute("data-x-hovered");

          setIndex(index);
        }}
        href={`#${index}`}
      >
        {COMPONENT_READABLE_NAME[el.name]}
      </a>
      <button ref={setActivatorNodeRef} {...listeners}>
        <Icon name="drag_indicator" />
      </button>
    </li>
  );
};

const DragContainer = styled.ul`
  padding: 0;
  margin: 0;
  gap: 10px;
  display: flex;
  flex-direction: column;

  & li {
    padding: 0;
    list-style-type: none;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0.2);
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    box-sizing: border-box;
    line-height: 1em;

    a {
      user-select: none;
      display: flex;
      width: 100%;
      height: 100%;
      color: inherit;
      text-decoration: none;
      align-items: center;
      padding: 0 10px;
    }

    & button {
      width: 20px;
      text-align: center;
      border: 0;
      background-color: transparent;
      border-radius: 3px;
      height: 30px;
      font-size: 15px;
      padding: 0 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: black;
      cursor: move;
      color: #ffffff;
      margin: 5px 10px;

      &:hover {
        background-color: rgba(0, 0, 0, 0.2);
      }
    }
  }
`;
